module.exports = __webpack_public_path__ + "img/MX-A024035D-BS24W.9a1ea01c.png";